import jsonLogic from '@/plugins/jsonLogic'
import Configuration from '@/agilis/util/Configuration'
import linkToMixin from '@/agilis/components/DataTableV2/common/linkToMixin'
import { mapActions } from 'vuex'
import i18n from '@/i18n/i18n'
import MetricTitle from '../MetricTitle/MetricTitle.vue'

export default {
  name: 'DashboardCounter',

  components: {
    MetricTitle
  },

  mixins: [linkToMixin],

  props: {
    metric: Object,
    items: [Array, Number, String],
    loading: [Boolean, String],
    query: Object,
    context: Object,
    onFireQuery: Function
  },

  data () {
    return {
      detailsModal: false,
      loadingDetail: false,
      detailItems: null
    }
  },

  computed: {
    result () {
      const logic = this.metric.formula?.jsonLogic
      const items = this.items

      // No array, return value as is
      if (!Array.isArray(items)) return items

      // No logic: return number of items
      if (!logic) {
        return items.length
      }

      // Apply the logic: count items matching the formula
      const result = items && items.reduce((a, b) => {
        const output = jsonLogic.apply(logic, b)
        if (output === true) {
          a++
        } else if (typeof output === 'number') {
          a = a + output
        } else if (typeof output === 'string') {
          a = output
        }
        return a
      }, 0)

      return result.toLocaleString(i18n.locale, {
        maximumFractionDigits: 2
      })
    },

    style () {
      const styles = []
      const decorations = this.metric.style || {}

      for (const style in decorations) {
        const decoration = decorations[style]?.jsonLogic ? jsonLogic.apply(decorations[style]?.jsonLogic, { result: this.result, items: this.items }) : decorations[style]
        styles.push(decoration)
      }

      return styles.join(' ')
    },

    detailDataTable () {
      const { dataTable, query } = this.metric.detail
      const queryDataTable = this.context.query[query.id || this.query.id].dataTable

      return Configuration.datatable.mergeQueryDataTable(dataTable, queryDataTable, { addQueryFields: false })
    },

    detailHeaders () {
      return Configuration.datatable.getHeaders(this.detailDataTable)
    },

    dataTableConfiguration () {
      return this.detailDataTable
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError'
    }),

    async loadDetails () {
      const { query, sortBy } = this.metric.detail
      this.loadingDetail = true

      let items
      let logic

      if (!query) { // using original resultSet + formula
        logic = this.metric.formula?.jsonLogic
        items = this.items
      } else {
        logic = this.metric.detail.formula?.jsonLogic

        try {
          const response = await this.onFireQuery(query, sortBy, true)
          items = response.items
        } catch (error) {
          this.detailsModal = false
          this.notifyError(error)
        }
      }

      // Post process items with jsonLogic
      this.detailItems = items && items.filter((item) => {
        const output = logic ? jsonLogic.apply(logic, item) : true
        return output === true
      }, 0)
      this.loadingDetail = false
    },

    renderColumn (colId, item) {
      const colConfig = this.detailDataTable.columns[colId]
      return Configuration.datatable.renderColumn(colConfig, item)
    }
  },

  watch: {
    detailsModal (openModal) {
      if (openModal === true && (!this.detailItems || this.detailItems.length === 0)) {
        setTimeout(() => this.loadDetails(), 0)
      }
    },
    context () {
      this.detailItems = [] // clearing detailItems to force reload
    }
  }
}
